import api from '../api';

export const deleteAppsService = async (appId: string): Promise<void> => {
  await api.delete(`/apps/${appId}`);
};
